import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Unknown from './views/Unknown.vue'
import Member from './views/Member'
import Search from './views/Search.vue'
import Login from './views/security/Login'
import Forgot from './views/security/Forgot'
import Reset from './views/security/Reset'
import NotFound from './views/NotFound.vue'
import About from './views/About.vue'
import Help from './views/Help.vue'
import Database from './views/Database'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '*',
      redirect: {
        path: '/404'
      }
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/unknown',
      name: 'unknown',
      component: Unknown
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/database',
      name: 'database',
      component: Database,
      meta: { auth: true }
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: { auth: true }
    },
    {
      path: '/member',
      name: 'member',
      component: Member,
      meta: { auth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { auth: false }
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: Forgot,
      meta: { auth: false }
    },
    {
      path: '/reset/:token',
      name: 'reset',
      component: Reset,
      meta: { auth: false }
    }
  ]
})

export default router
